import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { addIcons } from 'ionicons';
import { chevronBack, chevronForward } from 'ionicons/icons';
import { AdService } from '../../core/ad.service';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule],
    selector: 'image-gallery',
    styleUrls: ['./image-gallery.scss'],
    templateUrl: './image-gallery.html',
    standalone: true
})
export class ImageGalleryComponent implements OnInit {
  bucketURL: string = environment.firebase.bucketURL;
  @Input() adid: string = '';
  @Input() customerid: string = '';

  hero: any;
  gallery: any;
  images: any;
  thumbs: boolean = false;
  sliderOpts: any;
  thumbsOpts: any;

  constructor(
    private as: AdService
  ) {
    addIcons({
      'chevron-back': chevronBack,
      'chevron-forward': chevronForward,
    });
  }
  
  loadImage(image: any) {
    this.hero = image;
  }

  ngOnInit() {
    this.gallery = this.as.getAdGallery(this.customerid,this.adid).subscribe(image => {
      this.hero = image[0];
      this.images = image;
      if(image.length > 1) {
        this.thumbs = true;
        this.thumbsOpts = {
          spaceBetween: 16,
          slidesPerView: 3,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        }
      }
    })
  }
}
